import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { SelectBox } from '../molecules/select-box';
import { SpotPricePeriod } from '../shared';
import { useSelector } from '../store/utils';

const periods = [
  {
    label: (
      <FormattedMessage id="spot.price.period.60min" defaultMessage="60 min" />
    ),
    value: SpotPricePeriod['60M'],
  },
  {
    label: (
      <FormattedMessage id="spot.price.period.15min" defaultMessage="15 min" />
    ),
    value: SpotPricePeriod['15M'],
  },
];

type Props = {
  plugIndex: number;
};

export const PlugPeriodSelect = ({ plugIndex }: Props) => {
  const spPricePeriod = useSelector((state) => state.variables.SP_PRICE_PERIOD);

  const options = useMemo(() => {
    // 60M always available
    const period60M = periods.filter(
      (option) => option.value === SpotPricePeriod['60M']
    );

    // 15M is only visible if the global period is 15M
    if (spPricePeriod === SpotPricePeriod['15M']) {
      return periods;
    }

    return period60M;
  }, [spPricePeriod]);

  return (
    <SelectBox
      title={
        <FormattedMessage
          id="plug.spot.price.period"
          defaultMessage="Časové rozlišení zásuvky"
        />
      }
      selectVariableId={`PL_SP_PRICE_PERIOD[${plugIndex}]`}
      options={options}
      fullWidth
    />
  );
};
